import React from "react";
// import { Link } from 'react-router';
// import ReactLoading from 'react-loading';
import { connect } from "react-redux";
// import { browserHistory } from 'react-router';
import { bindActionCreators } from "redux";
import * as specialistActions from "../../actions/specialistActions";
import * as SVGICONS from "../../images/img/images";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import TimePicker from "react-bootstrap-time-picker";
// import TimePicker from 'rc-time-picker';
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import Autocomplete from "react-google-autocomplete";
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import $ from 'jquery';
import TimezonePicker from "react-timezone";
import * as dashboardActions from "../../actions/dashboardActions";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import { Form, Col, Container, Row } from "react-bootstrap";
// import TimePicker from 'tui-time-picker';

import "./../../styles/css/specialistAvailibilityNew.css";
import AntSwitch from "./../miniComponents/AntSwitch";
import Grid from "@material-ui/core/Grid";
import { Typography, Avatar } from "@material-ui/core";
import SelectTimezoneMaterialUi from "input-material-ui";
import validator from "./../common/validator.js";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import CameraAltOutlined from "@material-ui/icons/CameraAltOutlined";
import SaveIcon from "@material-ui/icons/Save";
import * as constant from "../../constants/constant";


class Availability extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state={
      viewProPicUploadDialog: false,
      tempImageObj: null,
      tempBannerImage: "",
      clinicImageObj: null,
      secondBanner:false,
      bannerImage : "https://test.medfixhealth.com/uploads/"+localStorage.getItem('userId')+"\\/" +this.props.clinicBannerImage,
      bannerImageDeleted: false,
    }

    this.handleChange.bind(this);
    this.handleClinicBannerImage.bind(this);
    this.handleClickOpen.bind(this);
    this.submitUploadedClinicImg.bind(this);
    this.handleClose.bind(this);
    this.deleteImage = this.deleteImage.bind(this);
  }

  handleClose = (event) => {
    this.setState({
      viewProPicUploadDialog: false,
      tempImageObj: null,
    })
    return
  }

  ConfirmClose=(event)=>{
    this.setState({
      secondBanner: true
    })
    return
  }
  handleClose2=(event)=>{
    this.setState({
      secondBanner:false,
    })
    return
  }

  UploadClinicBanner=(event)=>{
    console.log('hi',this.state.tempImageObj,this.state.clinicImageObj)
  
    this.props.UploadClinicBanner(this.state.tempImageObj,this.state.clinicImageObj)
    setTimeout(()=>{
    this.handleClose()
    },100)
 
  
  }


  deleteImage(){
    console.log('deleting')
    var state = this.state
    state.secondBanner = false
    state.viewProPicUploadDialog = false
    state.tempImageObj = null
    state.bannerImageDeleted = true
    state.bannerImage = ""
    this.setState(state)
    

    this.props.removeClinicBanner()
    

  }

  submitUploadedClinicImg = (event) => {

  }

  handleClinicBannerImage = (event) => {
    event.preventDefault();
    if (event.target.name == "image") {
      if (event.target.files.length > 0) {
        if (!validator.ImageValidateFormate(event.target.files[0])) {
          toast.error("Please choose following format jpeg, jpg, png, gif");
        } else if (!validator.fileValidateSize(event.target.files[0])) {
          toast.error("File size must be less than 10 MB.");
        } else {
          let reader = new FileReader();
          let file = event.target.files[0];

          reader.onloadend = () => {
            this.setState({
              file: file,
              defaultImageURL: reader.result,
            });
          };

          reader.readAsDataURL(file);
          this.setState({ [event.target.name]: event.target.files[0] });
          let clinicBannerObj = {
            file: event.target.files[0],
            userId: localStorage.getItem("userId"),
            clinicId: this.props.availId
          };

          this.setState({
            clinicImageObj: clinicBannerObj,
            tempImageObj: URL.createObjectURL(event.target.files[0])  
          })
  }

}}
  }

  handleClickOpen = () => {
    this.setState({ viewProPicUploadDialog: true });
  };



  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.checked });
  };

  componentWillMount() {
    this.props.actions.getCountriesList();
  }
  componentDidMount() {}

  componentWillReceiveProps(nextProps) {

    var state = this.state
    if(state['bannerImageDeleted'] == false){

      state['bannerImage'] = "https://test.medfixhealth.com/uploads/"+localStorage.getItem('userId')+"\/" +this.props.clinicBannerImage
    }

    this.setState(state)
  }

  componentDidUpdate(nextProps, nextState) {
    // document.getElementById('stateName').value = this.props.stateName.value;
  }



  render() {
    var countryList = this.props.countryList;
    var stateList = this.props.stateList;
    var countryCodeList = this.props.phoneCodeList;
    var currencyList = this.props.currencyList;
    return (
      <div className="modal-content specialistLoc r_modal">

   
        <form
          className="mobilepaddingtop"
          onSubmit={this.props.submitAvailability.bind(this)}
        >
          
        
          <div className="modal-body ">
          <div className="modal-head"> 
            <div className="leftSide">
            <button
            style={{ fontSize: '30px', position: 'absolute',left: -5, top: '5px' }}
            type="button"
            className="closeModal"
            data-dismiss="modal"
            aria-label="Close"
            onClick={this.props.closeModal}
          >
            x
          </button>
          <h4 className="modalHeading">{this.props.availId !== "" ? "Edit Clinic" : "Add New Clinic" }</h4>
            </div>

            <div className="rightSide">

                          <button
                            type="submit"
                            data-toggle="modal"
                            data-target="#modal-default"
                                  className="btn btn-square save-btn"
                                  onClick={this.saveSpecialistProfile}
                                  style={{fontSize:'13px', height: '40px', width: '90px'}}
                                >
                                  <span className="btn-text">Save</span>
                                </button>

                    
            </div>


          </div>



            {this.props.clinicInfo.length > 0 ? (
              <div className="row  checkconsult">
                <div className="col-md-2">
                  <h4 style={{marginBottom:'0px',fontSize: '16px !important',fontFamily:'roboto',fontWeight: 400,}}>Clinic Type</h4>
                </div>
                <div className="col-md-2">
                  <div className="boxMrgB boxMrgT">
                    <div className="radio radio-primary">
                      <input
                        type="radio"
                        name="isPrimary"
                        onChange={this.props.changePrimaryLocation}
                        id="isPrimary1"
                        defaultValue={this.props.isPrimary.value}
                        checked={
                          this.props.isPrimary.value
                          ? this.props.isPrimary.value === "true"
                          : "false"

                        }
                      />
                      <label style={{ cursor: "pointer" }} htmlFor="isPrimary1">
                        {" "}
                        Primary{" "}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="boxMrgB boxMrgT">
                    <div className="radio radio-primary">
                      <input
                        type="radio"
                        name="isPrimary"
                        onChange={this.props.changePrimaryLocation}
                        id="isPrimary2"
                        defaultValue={this.props.isPrimary.value}
                        checked={
                          this.props.isPrimary.value
                            ? this.props.isPrimary.value === "false"
                            : "true"

                        }
                      />
                      <label style={{ cursor: "pointer" }} htmlFor="isPrimary2">
                        {" "}
                        Other{" "}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="row  checkconsult">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                  <h4>Clinic type</h4>
                </div>
                <div className="col-md-3">
                  <div className="boxMrgB boxMrgT">
                    <div className="radio radio-primary">
                      <input
                        type="radio"
                        name="isPrimary"
                        disabled={true}
                        onChange={this.props.changePrimaryLocation}
                        id="isPrimary1"
                        defaultValue={true}
                        checked={true}
                      />
                      <label style={{ cursor: "pointer" }} htmlFor="isPrimary1">
                        {" "}
                        Primary{" "}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="boxMrgB boxMrgT">
                    <div className="radio radio-primary">
                      <input
                        type="radio"
                        name="isPrimary"
                        disabled={true}
                        onChange={this.props.changePrimaryLocation}
                        id="isPrimary2"
                        defaultValue={this.props.isPrimary.value}
                        checked={false}
                      />
                      <label style={{ cursor: "pointer" }} htmlFor="isPrimary2">
                        {" "}
                        Other{" "}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <Row style={{height: 48}}>
              <Col lg={5}>
                <TextField
                  type="text"
                  name="clinicName"
                  onChange={this.props.changeInAvailability}
                  defaultValue={this.props.clinicName.value}
                  id="clinicName"
                  placeholder="Clinic Name"
                  required
                  fullWidth
                  label="Clinic Name"
                />
                <span className="help-block">
                  {this.props.clinicName && this.props.clinicName.message}
                </span>
              </Col>
              <Col lg={5}>
                <div className="input-group inputBg city">
                  <span className="input-group-addon">
                    <SVGICONS.ZipCodeInputSvg />
                  </span>

                  {/* <input type="text" defaultValue={this.props.zipCode.value} onChange={this.props.checkZipCode} name="zipCode" className="form-control cityinput" placeholder="Near City, Zip Code" /> */}
                  <Autocomplete
                    id="autocomplete"
                    className="form-control cityinput"
                    data-toggle="tooltip"
                    data-placement="right"
                    title="Country, State and City will be automatically filled"
                    id="inputAddress2"
                    placeholder="Zip Code"
                    name="Address"
                    value={this.props.Address.value}
                    onChange={this.props.changeInAvailability}
                    onPlaceSelected={this.props.updateAddress}
                    types={["(regions)"]}
                  />

                </div>
                <span className="help-block">
                  {this.props.zipCode && this.props.zipCode.message}
                </span>
              </Col>
              <Col lg={2}></Col>
            </Row>
            <Row className="p-t-25"></Row>

            <Row style={{height: 48}}>
              <Col lg={{ span: 5, offset: 0.5 }}>
                <TextField
                  type="text"
                  id="state"
                  value={this.props.country.value}
                  disabled={this.props.isDisabled.country}
                  onChange={this.props.changeInAvailability}
                  name="country"
                  label="Country"
                  className="form-control cityinput capitalize"
                  placeholder="Country"
                />
                <span className="help-block">
                  {this.props.country && this.props.country.message}
                </span>
              </Col>
              <Col lg={{ span: 5, offset: 0.5 }}>
                <TextField
                  type="text"
                  id="state"
                  value={this.props.stateName.value}
                  disabled={this.props.isDisabled.state}
                  onChange={this.props.changeInAvailability}
                  label="State"
                  name="stateName"
                  className="form-control cityinput"
                  placeholder="State"
                />
                <span className="help-block">
                  {this.props.stateName && this.props.stateName.message}
                </span>
              </Col>
              <Col lg={2}></Col>
            </Row>
            <Row className="p-t-25"></Row>

            <Row style={{height: 48}}>
              <Col lg={{ span: 5, offset: 0.5 }}>
                <TextField
                  type="text"
                  label="City"
                  id="city"
                  value={this.props.city.value}
                  disabled={this.props.isDisabled.city}
                  onChange={this.props.changeInAvailability}
                  name="city"
                  className="form-control cityinput"
                  placeholder="City"
                />
                <span className="help-block">
                  {this.props.city && this.props.city.message}
                </span>
              </Col>
              <Col lg={{ span: 5, offset: 0.5 }}>
                <TextField
                  type="text"
                  name="addressLineOne"
                  id="addressLineOne"
                  label="Address"
                  placeholder="Consultation Address"
                  className="form-control"
                  onChange={this.props.changeInAvailability}
                  value={this.props.addressLineOne.value}
                />
                <span className="help-block">
                  {this.props.addressLineOne &&
                    this.props.addressLineOne.message}
                </span>
              </Col>
              <Col lg={2}></Col>
            </Row>
            <Row className="p-t-25"></Row>

            <Row>
              <Col lg={{ span: 5, offset: 0.5 }}>
                <Row style={{ padding: "0px 15px" }}>
                  <Col
                    lg={{ span: 5, offset: 0.5 }}
                    style={{ padding: "0px", paddingRight: 15 }}
                  >
                    <TextField
                      select
                      defaultValue={this.props.phoneCode1.value}
                      onChange={this.props.changeInAvailability.bind(this)}
                      // style={{ width: "100%", padding: "0px" }}
                      fullWidth
                      name="phoneCode1"
                      label="Country"
                    >
                      {(countryCodeList && countryCodeList.length) > 0
                        ? countryCodeList.map((option, index) => (
                            <MenuItem key={index} value={option}>
                              {option}
                            </MenuItem>
                          ))
                        : ""}
                    </TextField>
                    <span style={{ marginRight: 10 }} className="help-block">
                      {this.props.phoneCode1 && this.props.phoneCode1.message}
                    </span>
                  </Col>
                  <Col lg={7} style={{ padding: "0px", width: "100%" }}>
                    <TextField
                      type="text"
                      defaultValue={this.props.mobileNo.value}
                      onChange={this.props.changeInAvailability.bind(this)}
                      name="mobileNo"
                      // style={{ width: "100%", }}
                      fullWidth
                      label="Phone"
                      placeholder="Landline Number"
                    />
                    <span style={{ marginRight: 10 }} className="help-block">
                      {this.props.mobileNo && this.props.mobileNo.message}
                    </span>
                  </Col>
                </Row>
              </Col>
              <Col lg={{ span: 5, offset: 0.5 }}>
                <Row style={{ padding: "0px 15px"}}>
                  <Col lg={5} style={{ padding: "0px", paddingRight: 15 }}>
                    <TextField
                      select
                      name="currencySymbol"
                      label="Currency"
                      defaultValue={this.props.currencySymbol.value}
                      onChange={this.props.changeInAvailability.bind(this)}
                      fullWidth
                    >
                      {(currencyList && currencyList.length) > 0
                        ? currencyList.map((option, index) => (
                            <MenuItem key={index} value={option}>
                              {option}
                            </MenuItem>
                          ))
                        : ""}
                    </TextField>
                    <span style={{ marginRight: 10 }} className="help-block">
                      {this.props.currencySymbol &&
                        this.props.currencySymbol.message}
                    </span>
                  </Col>
                  <Col lg={7} style={{ padding: "0px" }}>
                    <TextField
                      type="text"
                      defaultValue={this.props.fee.value}
                      onChange={this.props.changeInAvailability}
                      name="fee"
                      // style={{ width: '100%' }}
                      fullWidth
                      label="Consultation Fees"
                      placeholder="Consultation Fees"
                    />
                    <span style={{ marginRight: 10 }} className="help-block">
                      {this.props.fee && this.props.fee.message}
                    </span>
                  </Col>
                </Row>
              </Col>
              <Col lg={2}></Col>
            </Row>
            <Row className="p-t-25"></Row>

            <Row>
              <Col lg={5}>
                <div className=" timezonepicker" style={{zIndex: '10000'}}>
                  <TimezonePicker
                    fullWidth
                    onChange={this.props.timezones}
                    inputProps={{
                      placeholder: this.props.timezoner.value,
                      name: "timezoner",
                    }}
                  />

      
                  <span style={{ marginRight: 10 }} className="help-block">
                    {this.props.timezoner && this.props.timezoner.message}
                  </span>
                </div>
              </Col>
              <Col lg={7}></Col>
            </Row>

            <div className="row m-t checkconsult">
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <h4>Clinic Schedule</h4>
              </div>
            </div>
          
            <Row style={{justifyContent:'left'}}>
              <Col lg={12}>

            <div className="days">
              <div className="day-row">
                <div className="switch">
                  <AntSwitch
                    onChange={this.props.changeInAvailability}
                    value={this.props.sunday.value}
                    checked={
                      this.props.sunday && this.props.sunday.value == true
                        ? true
                        : false
                    }
                    name="sunday"
                  />
                  <p>Sunday</p>
                </div>
                {this.props.sunday && this.props.sunday.value == true ? (
                  <div className="timepickers">
                    <div className="morningTime">
                      <div>
                      <input
                        type="checkbox"
                        onChange={this.props.changeInAvailability}
                        defaultValue={this.props.sundayMorning.value}
                        name="sundayMorning"
                        id="sundayMorning"
                        checked={
                          this.props.sundayMorning &&
                          this.props.sundayMorning.value == true
                            ? true
                            : false
                        }
                      />
                      <label htmlFor="sundayMorning" className="startReview">
                        <span>
                          <strong>M</strong>
                        </span>{" "}
                      </label>

                      <TimePicker
                        style={{
                          marginLeft: 6,
                          border: "none",
                          fontSize: 14,
                          minWidth: 90,
                        }}
                        disabled={this.props.sundayMorning.value}
                        value={
                          this.props.sundayMorningSchedule
                            ? this.props.sundayMorningSchedule.inTime
                            : "08:00"
                        }
                        id="mornT"
                        format={24}
                        step={30}
                        onChange={this.props.handleSundayMSTimeChange.bind(
                          this
                        )}
                        start={this.props.sundayMornSTValid.start}
                        end={this.props.sundayMornSTValid.end}
                      />
                      <span>am</span>
                      <p style={{ marginLeft: 10 }}>
                        <strong>to</strong>
                      </p>
                      <TimePicker
                        style={{
                          marginLeft: 6,
                          border: "none",
                          fontSize: 14,
                          minWidth: 90,
                        }}
                        disabled={this.props.sundayMorning.value}
                        value={
                          this.props.sundayMorningSchedule
                            ? this.props.sundayMorningSchedule.outTime
                            : "11:00"
                        }
                        id="mornT"
                        format={24}
                        step={30}
                        onChange={this.props.handleSundayMETimeChange.bind(
                          this
                        )}
                        start={this.props.sundayMorningSchedule.inTime}
                        end={this.props.sundayMornETValid.end}
                      />
                      <span>am</span>
                      </div>
                      <div>
													<span className="help-block">{this.props.sunday && this.props.sundayMorningSchedule.message}</span>
												</div>
                    </div>
                  
                  
                    <div className="timeDivider"></div>
                    <div className="eveningTime">
                      <div>
                      <input
                        type="checkbox"
                        onChange={this.props.changeInAvailability}
                        defaultValue={this.props.sundayEvening.value}
                        name="sundayEvening"
                        id="sundayEvening"
                        checked={
                          this.props.sundayEvening &&
                          this.props.sundayEvening.value == true
                            ? true
                            : false
                        }
                      />
                      <label htmlFor="sundayEvening" className="startReview">
                        <span>
                          <strong>E</strong>
                        </span>{" "}
                      </label>
                      <TimePicker
                        style={{
                          marginLeft: 6,
                          border: "none",
                          fontSize: 14,
                          minWidth: 90,
                        }}
                        disabled={this.props.sundayEvening.value}
                        value={
                          this.props.sundayEveningSchedule
                            ? this.props.sundayEveningSchedule.inTime
                            : "12:00"
                        }
                        id="mornT"
                        format={24}
                        step={30}
                        onChange={this.props.handleSundayESTimeChange.bind(
                          this
                        )}
                        start={this.props.sundayEvenSTValid.start}
                        end={this.props.sundayEvenSTValid.end}
                      />
                      <span>pm</span>
                      <p style={{ marginLeft: 10 }}>
                        <strong>to</strong>
                      </p>
                      <TimePicker
                        style={{
                          marginLeft: 6,
                          border: "none",
                          fontSize: 14,
                          minWidth: 90,
                        }}
                        disabled={this.props.sundayEvening.value}
                        value={
                          this.props.sundayEveningSchedule
                            ? this.props.sundayEveningSchedule.outTime
                            : "23:30"
                        }
                        id="mornT"
                        format={24}
                        step={30}
                        onChange={this.props.handleSundayEETimeChange.bind(
                          this
                        )}
                        start={this.props.sundayEveningSchedule.inTime}
                        end={this.props.sundayEvenETValid.end}
                      />
                      <span>pm</span>
                      </div>
                          <div>
													<span className="help-block">{this.props.sunday && this.props.sundayEveningSchedule.message}</span>
												</div>
                    </div>
                
                    
                  </div>
                ) : null}{" "}
              </div>

              <div className="day-row">
                <div className="switch">
                  <AntSwitch
                    onChange={this.props.changeInAvailability}
                    value={this.props.monday.value}
                    checked={
                      this.props.monday && this.props.monday.value == true
                        ? true
                        : false
                    }
                    name="monday"
                  />
                  <p>Monday</p>
                </div>
                {this.props.monday && this.props.monday.value == true ? (
                  <div className="timepickers">
                    <div className="morningTime">
                      <div>
                      <input
                        type="checkbox"
                        onChange={this.props.changeInAvailability}
                        defaultValue={this.props.mondayMorning.value}
                        name="mondayMorning"
                        id="mondayMorning"
                        checked={
                          this.props.mondayMorning &&
                          this.props.mondayMorning.value == true
                            ? true
                            : false
                        }
                      />
                      <label htmlFor="mondayMorning" className="startReview">
                        <span>
                          <strong>M</strong>
                        </span>{" "}
                      </label>
                      <TimePicker
                        style={{
                          marginLeft: 6,
                          border: "none",
                          fontSize: 14,
                          minWidth: 90,
                        }}
                        disabled={this.props.mondayMorning.value}
                        value={
                          this.props.mondayMorningSchedule
                            ? this.props.mondayMorningSchedule.inTime
                            : "08:00"
                        }
                        id="mornT"
                        format={24}
                        step={30}
                        onChange={this.props.handleMondayMSTimeChange.bind(
                          this
                        )}
                        start={this.props.mondayMornSTValid.start}
                        end={this.props.mondayMornSTValid.end}
                      />
                      <span>am</span>
                      <p style={{ marginLeft: 10 }}>
                        <strong>to</strong>
                      </p>
                      <TimePicker
                        style={{
                          marginLeft: 6,
                          border: "none",
                          fontSize: 14,
                          minWidth: 90,
                        }}
                        disabled={this.props.mondayMorning.value}
                        value={
                          this.props.mondayMorningSchedule
                            ? this.props.mondayMorningSchedule.outTime
                            : "12:00"
                        }
                        id="mornT"
                        format={24}
                        step={30}
                        onChange={this.props.handleMondayMETimeChange.bind(
                          this
                        )}
                        start={this.props.mondayMorningSchedule.inTime}
                        end={this.props.mondayMornETValid.end}
                      />
                      <span>am</span>
                      </div>
                      <div>
													<span className="help-block">{this.props.sunday && this.props.mondayMorningSchedule.message}</span>
												</div>
                    </div>
                    
                   
                    <div className="timeDivider"></div>
                    <div className="eveningTime">
                      <div>
                      <input
                        type="checkbox"
                        onChange={this.props.changeInAvailability}
                        defaultValue={this.props.mondayEvening.value}
                        name="mondayEvening"
                        id="mondayEvening"
                        checked={
                          this.props.mondayEvening &&
                          this.props.mondayEvening.value == true
                            ? true
                            : false
                        }
                      />
                      <label htmlFor="mondayEvening" className="startReview">
                        <span>
                          <strong>E</strong>
                        </span>{" "}
                      </label>

                      <TimePicker
                        style={{
                          marginLeft: 6,
                          border: "none",
                          fontSize: 14,
                          minWidth: 90,
                        }}
                        disabled={this.props.mondayEvening.value}
                        value={
                          this.props.mondayEveningSchedule
                            ? this.props.mondayEveningSchedule.inTime
                            : "12:00"
                        }
                        id="mornT"
                        format={24}
                        step={30}
                        onChange={this.props.handleMondayESTimeChange.bind(
                          this
                        )}
                        start={this.props.mondayEvenSTValid.start}
                        end={this.props.mondayEvenSTValid.end}
                      />
                      <span>pm</span>
                      <p style={{ marginLeft: 10 }}>
                        <strong>to</strong>
                      </p>
                      <TimePicker
                        style={{
                          marginLeft: 6,
                          border: "none",
                          fontSize: 14,
                          minWidth: 90,
                        }}
                        disabled={this.props.mondayEvening.value}
                        value={
                          this.props.mondayEveningSchedule
                            ? this.props.mondayEveningSchedule.outTime
                            : "23:30"
                        }
                        id="mornT"
                        format={24}
                        step={30}
                        onChange={this.props.handleMondayEETimeChange.bind(
                          this
                        )}
                        start={this.props.mondayEveningSchedule.inTime}
                        end={this.props.mondayEvenETValid.end}
                      />
                      <span>pm</span>
                      </div>
                      <div>
													<span className="help-block">{this.props.sunday && this.props.mondayEveningSchedule.message}</span>
												</div>
                    </div>
                     
                  
                  </div>
                ) : null}
              </div>

              <div className="day-row">
                <div className="switch">
                  <AntSwitch
                    onChange={this.props.changeInAvailability}
                    value={this.props.tuesday.value}
                    checked={
                      this.props.tuesday && this.props.tuesday.value == true
                        ? true
                        : false
                    }
                    name="tuesday"
                  />
                  <p>Tuesday</p>
                </div>

                {this.props.tuesday && this.props.tuesday.value == true ? (
                  <div className="timepickers">
                    <div className="morningTime">
                      <div>
                      <input
                        type="checkbox"
                        onChange={this.props.changeInAvailability}
                        defaultValue={this.props.tuesdayMorning.value}
                        name="tuesdayMorning"
                        id="tuesdayMorning"
                        checked={
                          this.props.tuesdayMorning &&
                          this.props.tuesdayMorning.value == true
                            ? true
                            : false
                        }
                      />
                      <label htmlFor="tuesdayMorning" className="startReview">
                        <span>
                          <strong>M</strong>
                        </span>{" "}
                      </label>
                      <TimePicker
                        style={{
                          marginLeft: 6,
                          border: "none",
                          fontSize: 14,
                          minWidth: 90,
                        }}
                        disabled={this.props.tuesdayMorning.value}
                        value={
                          this.props.tuesdayMorningSchedule
                            ? this.props.tuesdayMorningSchedule.inTime
                            : "08:00"
                        }
                        id="mornT"
                        format={24}
                        step={30}
                        onChange={this.props.handleTuesdayMSTimeChange.bind(
                          this
                        )}
                        start={this.props.tuesdayMornSTValid.start}
                        end={this.props.tuesdayMornSTValid.end}
                      />
                      <span>am</span>
                      <p style={{ marginLeft: 10 }}>
                        <strong>to</strong>
                      </p>
                      <TimePicker
                        style={{
                          marginLeft: 6,
                          border: "none",
                          fontSize: 14,
                          minWidth: 90,
                        }}
                        disabled={this.props.tuesdayMorning.value}
                        value={
                          this.props.tuesdayMorningSchedule
                            ? this.props.tuesdayMorningSchedule.outTime
                            : "11:00"
                        }
                        id="mornT"
                        format={24}
                        step={30}
                        onChange={this.props.handleTuesdayMETimeChange.bind(
                          this
                        )}
                        start={this.props.tuesdayMorningSchedule.inTime}
                        end={this.props.tuesdayMornETValid.end}
                      />
                      <span>am</span>
                      </div>
                      <div>
													<span className="help-block">{this.props.sunday && this.props.tuesdayMorningSchedule.message}</span>
												</div>
                    </div>
                     
                   
                    <div className="timeDivider"></div>
                    <div className="eveningTime">
                      <div>
                      <input
                        type="checkbox"
                        onChange={this.props.changeInAvailability}
                        defaultValue={this.props.tuesdayEvening.value}
                        name="tuesdayEvening"
                        id="tuesdayEvening"
                        checked={
                          this.props.tuesdayEvening &&
                          this.props.tuesdayEvening.value == true
                            ? true
                            : false
                        }
                      />
                      <label htmlFor="tuesdayEvening" className="startReview">
                        <span>
                          <strong>E</strong>
                        </span>{" "}
                      </label>

                      <TimePicker
                        style={{
                          marginLeft: 6,
                          border: "none",
                          fontSize: 14,
                          minWidth: 90,
                        }}
                        disabled={this.props.tuesdayEvening.value}
                        value={
                          this.props.tuesdayEveningSchedule
                            ? this.props.tuesdayEveningSchedule.inTime
                            : "12:00"
                        }
                        id="mornT"
                        format={24}
                        step={30}
                        onChange={this.props.handleTuesdayESTimeChange.bind(
                          this
                        )}
                        start={this.props.tuesdayEvenSTValid.start}
                        end={this.props.tuesdayEvenSTValid.end}
                      />
                      <span>pm</span>
                      <p style={{ marginLeft: 10 }}>
                        <strong>to</strong>
                      </p>
                      <TimePicker
                        style={{
                          marginLeft: 6,
                          border: "none",
                          fontSize: 14,
                          minWidth: 90,
                        }}
                        disabled={this.props.tuesdayEvening.value}
                        value={
                          this.props.tuesdayEveningSchedule
                            ? this.props.tuesdayEveningSchedule.outTime
                            : "23:30"
                        }
                        id="mornT"
                        format={24}
                        step={30}
                        onChange={this.props.handleTuesdayEETimeChange.bind(
                          this
                        )}
                        start={this.props.tuesdayEveningSchedule.inTime}
                        end={this.props.tuesdayEvenETValid.end}
                      />
                      <span>pm</span>
                      </div>
                      <div>
													<span className="help-block">{this.props.sunday && this.props.tuesdayEveningSchedule.message}</span>
												</div>
                    </div>
                     
                  
                  </div>
                ) : null}
              </div>

              <div className="day-row">
                <div className="switch">
                  <AntSwitch
                    onChange={this.props.changeInAvailability}
                    value={this.props.wednesday.value}
                    checked={
                      this.props.wednesday && this.props.wednesday.value == true
                        ? true
                        : false
                    }
                    name="wednesday"
                  />
                  <p>Wednesday</p>
                </div>

                {this.props.wednesday && this.props.wednesday.value == true ? (
                  <div className="timepickers">
                    <div className="morningTime">
                      <div>
                      <input
                        type="checkbox"
                        onChange={this.props.changeInAvailability}
                        defaultValue={this.props.wednesdayMorning.value}
                        name="wednesdayMorning"
                        id="wednesdayMorning"
                        checked={
                          this.props.wednesdayMorning &&
                          this.props.wednesdayMorning.value == true
                            ? true
                            : false
                        }
                      />
                      <label htmlFor="wednesdayMorning" className="startReview">
                        <span>
                          <strong>M</strong>
                        </span>{" "}
                      </label>

                      <TimePicker
                        style={{
                          marginLeft: 6,
                          border: "none",
                          fontSize: 14,
                          minWidth: 90,
                        }}
                        disabled={this.props.wednesdayMorning.value}
                        value={
                          this.props.wednesdayMorningSchedule
                            ? this.props.wednesdayMorningSchedule.inTime
                            : "08:00"
                        }
                        id="mornT"
                        format={24}
                        step={30}
                        onChange={this.props.handleWednesdayMSTimeChange.bind(
                          this
                        )}
                        start={this.props.wednesdayMornSTValid.start}
                        end={this.props.wednesdayMornSTValid.end}
                      />
                      <span>am</span>
                      <p style={{ marginLeft: 10 }}>
                        <strong>to</strong>
                      </p>
                      <TimePicker
                        style={{
                          marginLeft: 6,
                          border: "none",
                          fontSize: 14,
                          minWidth: 90,
                        }}
                        disabled={this.props.wednesdayMorning.value}
                        value={
                          this.props.wednesdayMorningSchedule
                            ? this.props.wednesdayMorningSchedule.outTime
                            : "11:00"
                        }
                        id="mornT"
                        format={24}
                        step={30}
                        onChange={this.props.handleWednesdayMETimeChange.bind(
                          this
                        )}
                        start={this.props.wednesdayMorningSchedule.inTime}
                        end={this.props.wednesdayMornETValid.end}
                      />
                      <span>am</span>
                      </div>
                      <div>
													<span className="help-block">{this.props.sunday && this.props.wednesdayMorningSchedule.message}</span>
												</div>
                    </div>
                     
                
                    <div className="timeDivider"></div>
                    <div className="eveningTime">
                      <div>
                      <input
                        type="checkbox"
                        onChange={this.props.changeInAvailability}
                        defaultValue={this.props.wednesdayEvening.value}
                        name="wednesdayEvening"
                        id="wednesdayEvening"
                        checked={
                          this.props.wednesdayEvening &&
                          this.props.wednesdayEvening.value == true
                            ? true
                            : false
                        }
                      />
                      <label htmlFor="wednesdayEvening" className="startReview">
                        <span>
                          <strong>E</strong>
                        </span>{" "}
                      </label>
                      <TimePicker
                        style={{
                          marginLeft: 6,
                          border: "none",
                          fontSize: 14,
                          minWidth: 90,
                        }}
                        disabled={this.props.wednesdayEvening.value}
                        value={
                          this.props.wednesdayEveningSchedule
                            ? this.props.wednesdayEveningSchedule.inTime
                            : "12:00"
                        }
                        id="mornT"
                        format={24}
                        step={30}
                        onChange={this.props.handleWednesdayESTimeChange.bind(
                          this
                        )}
                        start={this.props.wednesdayEvenSTValid.start}
                        end={this.props.wednesdayEvenSTValid.end}
                      />
                      <span>pm</span>
                      <p style={{ marginLeft: 10 }}>
                        <strong>to</strong>
                      </p>
                      <TimePicker
                        style={{
                          marginLeft: 6,
                          border: "none",
                          fontSize: 14,
                          minWidth: 90,
                        }}
                        disabled={this.props.wednesdayEvening.value}
                        value={
                          this.props.wednesdayEveningSchedule
                            ? this.props.wednesdayEveningSchedule.outTime
                            : "23:30"
                        }
                        id="mornT"
                        format={24}
                        step={30}
                        onChange={this.props.handleWednesdayEETimeChange.bind(
                          this
                        )}
                        start={this.props.wednesdayEveningSchedule.inTime}
                        end={this.props.wednesdayEvenETValid.end}
                      />
                      <span>pm</span>
                      </div>
                    <div>
													<span className="help-block">{this.props.sunday && this.props.wednesdayEveningSchedule.message}</span>
												</div>
                    </div>
                
                  </div>
                ) : null}
              </div>

              <div className="day-row">
                <div className="switch">
                  <AntSwitch
                    onChange={this.props.changeInAvailability}
                    value={this.props.thursday.value}
                    checked={
                      this.props.thursday && this.props.thursday.value == true
                        ? true
                        : false
                    }
                    name="thursday"
                  />
                  <p>Thursday</p>
                </div>

                {this.props.thursday && this.props.thursday.value == true ? (
                  <div className="timepickers">
                    <div className="morningTime">
                      <div>
                      <input
                        type="checkbox"
                        onChange={this.props.changeInAvailability}
                        defaultValue={this.props.thursdayMorning.value}
                        name="thursdayMorning"
                        id="thursdayMorning"
                        checked={
                          this.props.thursdayMorning &&
                          this.props.thursdayMorning.value == true
                            ? true
                            : false
                        }
                      />
                      <label htmlFor="thursdayMorning" className="startReview">
                        <span>
                          <strong>M</strong>
                        </span>{" "}
                      </label>
                      <TimePicker
                        style={{
                          marginLeft: 6,
                          border: "none",
                          fontSize: 14,
                          minWidth: 90,
                        }}
                        disabled={this.props.thursdayMorning.value}
                        value={
                          this.props.thursdayMorningSchedule
                            ? this.props.thursdayMorningSchedule.inTime
                            : "08:00"
                        }
                        id="mornT"
                        format={24}
                        step={30}
                        onChange={this.props.handleThursdayMSTimeChange.bind(
                          this
                        )}
                        start={this.props.thursdayMornSTValid.start}
                        end={this.props.thursdayMornSTValid.end}
                      />
                      <span>am</span>
                      <p style={{ marginLeft: 10 }}>
                        <strong>to</strong>
                      </p>
                      <TimePicker
                        style={{
                          marginLeft: 6,
                          border: "none",
                          fontSize: 14,
                          minWidth: 90,
                        }}
                        disabled={this.props.thursdayMorning.value}
                        value={
                          this.props.thursdayMorningSchedule
                            ? this.props.thursdayMorningSchedule.outTime
                            : "11:00"
                        }
                        id="mornT"
                        format={24}
                        step={30}
                        onChange={this.props.handleThursdayMETimeChange.bind(
                          this
                        )}
                        start={this.props.thursdayMorningSchedule.inTime}
                        end={this.props.thursdayMornETValid.end}
                      />
                      <span>am</span>
                      </div>
                      <div>
													<span className="help-block">{this.props.sunday && this.props.thursdayMorningSchedule.message}</span>
												</div>
                    </div>
                     
                   
                    <div className="timeDivider"></div>
                    <div className="eveningTime">
                      <div>
                      <input
                        type="checkbox"
                        onChange={this.props.changeInAvailability}
                        defaultValue={this.props.thursdayEvening.value}
                        name="thursdayEvening"
                        id="thursdayEvening"
                        checked={
                          this.props.thursdayEvening &&
                          this.props.thursdayEvening.value == true
                            ? true
                            : false
                        }
                      />
                      <label htmlFor="thursdayEvening" className="startReview">
                        <span>
                          <strong>E</strong>
                        </span>{" "}
                      </label>
                      <TimePicker
                        style={{
                          marginLeft: 6,
                          border: "none",
                          fontSize: 14,
                          minWidth: 90,
                        }}
                        disabled={this.props.thursdayEvening.value}
                        value={
                          this.props.thursdayEveningSchedule
                            ? this.props.thursdayEveningSchedule.inTime
                            : "12:00"
                        }
                        id="mornT"
                        format={24}
                        step={30}
                        onChange={this.props.handleThursdayESTimeChange.bind(
                          this
                        )}
                        start={this.props.thursdayEvenSTValid.start}
                        end={this.props.thursdayEvenSTValid.end}
                      />
                      <span>pm</span>
                      <p style={{ marginLeft: 10 }}>
                        <strong>to</strong>
                      </p>
                      <TimePicker
                        style={{
                          marginLeft: 6,
                          border: "none",
                          fontSize: 14,
                          minWidth: 90,
                        }}
                        disabled={this.props.thursdayEvening.value}
                        value={
                          this.props.thursdayEveningSchedule
                            ? this.props.thursdayEveningSchedule.outTime
                            : "23:30"
                        }
                        id="mornT"
                        format={24}
                        step={30}
                        onChange={this.props.handleThursdayEETimeChange.bind(
                          this
                        )}
                        start={this.props.thursdayEveningSchedule.inTime}
                        end={this.props.thursdayEvenETValid.end}
                      />
                      <span>pm</span>
                      </div>
                      <div>
													<span className="help-block">{this.props.sunday && this.props.thursdayEveningSchedule.message}</span>
												</div>
                    </div>
                     
                    
                  </div>
                ) : null}
              </div>

              <div className="day-row">
                <div className="switch">
                  <AntSwitch
                    onChange={this.props.changeInAvailability}
                    value={this.props.friday.value}
                    checked={
                      this.props.friday && this.props.friday.value == true
                        ? true
                        : false
                    }
                    name="friday"
                  />
                  <p>Friday</p>
                </div>
                {this.props.friday && this.props.friday.value == true ? (
                  <div className="timepickers">
                    <div className="morningTime">
                      <div>
                      <input
                        type="checkbox"
                        onChange={this.props.changeInAvailability}
                        defaultValue={this.props.fridayMorning.value}
                        name="fridayMorning"
                        id="fridayMorning"
                        checked={
                          this.props.fridayMorning &&
                          this.props.fridayMorning.value == true
                            ? true
                            : false
                        }
                      />
                      <label htmlFor="fridayMorning" className="startReview">
                        <span>
                          <strong>M</strong>
                        </span>{" "}
                      </label>
                      <TimePicker
                        style={{
                          marginLeft: 6,
                          border: "none",
                          fontSize: 14,
                          minWidth: 90,
                        }}
                        disabled={this.props.fridayMorning.value}
                        value={
                          this.props.fridayMorningSchedule
                            ? this.props.fridayMorningSchedule.inTime
                            : "08:00"
                        }
                        id="mornT"
                        format={24}
                        step={30}
                        onChange={this.props.handleFridayMSTimeChange.bind(
                          this
                        )}
                        start={this.props.fridayMornSTValid.start}
                        end={this.props.fridayMornSTValid.end}
                      />
                      <span>am</span>
                      <p style={{ marginLeft: 10 }}>
                        <strong>to</strong>
                      </p>
                      <TimePicker
                        style={{
                          marginLeft: 6,
                          border: "none",
                          fontSize: 14,
                          minWidth: 90,
                        }}
                        disabled={this.props.fridayMorning.value}
                        value={
                          this.props.fridayMorningSchedule
                            ? this.props.fridayMorningSchedule.outTime
                            : "08:30"
                        }
                        id="mornT"
                        format={24}
                        step={30}
                        onChange={this.props.handleFridayMETimeChange.bind(
                          this
                        )}
                        start={this.props.fridayMorningSchedule.inTime}
                        end={this.props.fridayMornETValid.end}
                      />
                      <span>am</span>
                      </div>
                      <div>
													<span className="help-block">{this.props.FridayMorningSchedule && this.props.FridayMorningSchedule.message} </span>
												</div>
                    </div>
 
               
                    <div className="timeDivider"></div>
                    <div className="eveningTime">
                      <div>
                      <input
                        type="checkbox"
                        onChange={this.props.changeInAvailability}
                        defaultValue={this.props.fridayEvening.value}
                        name="fridayEvening"
                        id="fridayEvening"
                        checked={
                          this.props.fridayEvening &&
                          this.props.fridayEvening.value == true
                            ? true
                            : false
                        }
                      />
                      <label htmlFor="fridayEvening" className="startReview">
                        <span>
                          <strong>E</strong>
                        </span>{" "}
                      </label>
                      <TimePicker
                        style={{
                          marginLeft: 6,
                          border: "none",
                          fontSize: 14,
                          minWidth: 90,
                        }}
                        disabled={this.props.fridayEvening.value}
                        value={
                          this.props.fridayEveningSchedule
                            ? this.props.fridayEveningSchedule.inTime
                            : "12:00"
                        }
                        id="mornT"
                        format={24}
                        step={30}
                        onChange={this.props.handleFridayESTimeChange.bind(
                          this
                        )}
                        start={this.props.fridayEvenSTValid.start}
                        end={this.props.fridayEvenSTValid.end}
                      />
                      <span>pm</span>
                      <p style={{ marginLeft: 10 }}>
                        <strong>to</strong>
                      </p>
                      <TimePicker
                        style={{
                          marginLeft: 6,
                          border: "none",
                          fontSize: 14,
                          minWidth: 90,
                        }}
                        disabled={this.props.fridayEvening.value}
                        value={
                          this.props.fridayEveningSchedule
                            ? this.props.fridayEveningSchedule.outTime
                            : "23:30"
                        }
                        id="mornT"
                        format={24}
                        step={30}
                        onChange={this.props.handleFridayEETimeChange.bind(
                          this
                        )}
                        start={this.props.fridayEveningSchedule.inTime}
                        end={this.props.fridayEvenETValid.end}
                      />
                      <span>pm</span>
                      </div>
                      <div>
													<span className="help-block">{this.props.sunday && this.props.fridayEveningSchedule.message}</span>
												</div>
                    </div>
                     
                    
                  </div>
                ) : null}
              </div>

              <div className="day-row">
                <div className="switch">
                  <AntSwitch
                    onChange={this.props.changeInAvailability}
                    value={this.props.saturday.value}
                    checked={
                      this.props.saturday && this.props.saturday.value == true
                        ? true
                        : false
                    }
                    name="saturday"
                  />
                  <p>Saturday</p>
                </div>

                {this.props.saturday && this.props.saturday.value == true ? (
                  <div className="timepickers">
                    <div className="morningTime">
                      <div>
                      <input
                        type="checkbox"
                        onChange={this.props.changeInAvailability}
                        defaultValue={this.props.saturdayMorning.value}
                        name="saturdayMorning"
                        id="saturdayMorning"
                        checked={
                          this.props.sundayMorning &&
                          this.props.saturdayMorning.value == true
                            ? true
                            : false
                        }
                      />
                      <label htmlFor="saturdayMorning" className="startReview">
                        <span>
                          <strong>M</strong>
                        </span>{" "}
                      </label>
                      <TimePicker
                        style={{
                          marginLeft: 6,
                          border: "none",
                          fontSize: 14,
                          minWidth: 90,
                        }}
                        disabled={this.props.saturdayMorning.value}
                        value={
                          this.props.saturdayMorningSchedule
                            ? this.props.saturdayMorningSchedule.inTime
                            : "08:00"
                        }
                        id="mornT"
                        format={24}
                        step={30}
                        onChange={this.props.handleSaturdayMSTimeChange.bind(
                          this
                        )}
                        start={this.props.saturdayMornSTValid.start}
                        end={this.props.saturdayMornSTValid.end}
                      />
                      <span>am</span>
                      <p style={{ marginLeft: 10 }}>
                        <strong>to</strong>
                      </p>
                      <TimePicker
                        style={{
                          marginLeft: 6,
                          border: "none",
                          fontSize: 14,
                          minWidth: 90,
                        }}
                        disabled={this.props.saturdayMorning.value}
                        value={
                          this.props.saturdayMorningSchedule
                            ? this.props.saturdayMorningSchedule.outTime
                            : "08:30"
                        }
                        id="mornT"
                        format={24}
                        step={30}
                        onChange={this.props.handleSaturdayMETimeChange.bind(
                          this
                        )}
                        start={this.props.saturdayMorningSchedule.inTime}
                        end={this.props.saturdayMornETValid.end}
                      />
                      <span>am</span>
                      </div>
                      <div>
													<span className="help-block">{this.props.sunday && this.props.saturdayMorningSchedule.message}</span>
												</div>
                    </div>
 
                  
                    <div className="timeDivider"></div>
                    <div className="eveningTime">
                      <div>
                      <input
                        type="checkbox"
                        onChange={this.props.changeInAvailability}
                        defaultValue={this.props.saturdayEvening.value}
                        name="saturdayEvening"
                        id="saturdayEvening"
                        checked={
                          this.props.saturdayEvening &&
                          this.props.saturdayEvening.value == true
                            ? true
                            : false
                        }
                      />
                      <label htmlFor="saturdayEvening" className="startReview">
                        <span>
                          <strong>E</strong>
                        </span>{" "}
                      </label>
                      <TimePicker
                        style={{
                          marginLeft: 6,
                          border: "none",
                          fontSize: 14,
                          minWidth: 90,
                        }}
                        disabled={this.props.saturdayEvening.value}
                        value={
                          this.props.saturdayEveningSchedule
                            ? this.props.saturdayEveningSchedule.inTime
                            : "12:00"
                        }
                        id="mornT"
                        format={24}
                        step={30}
                        onChange={this.props.handleSaturdayESTimeChange.bind(
                          this
                        )}
                        start={this.props.saturdayEvenSTValid.start}
                        end={this.props.saturdayEvenSTValid.end}
                      />
                      <span>pm</span>
                      <p style={{ marginLeft: 10 }}>
                        <strong>to</strong>
                      </p>
                      <TimePicker
                        style={{
                          marginLeft: 6,
                          border: "none",
                          fontSize: 14,
                          minWidth: 90,
                        }}
                        disabled={this.props.saturdayEvening.value}
                        value={
                          this.props.saturdayEveningSchedule
                            ? this.props.saturdayEveningSchedule.outTime
                            : "23:30"
                        }
                        id="mornT"
                        format={24}
                        step={30}
                        onChange={this.props.handleSaturdayEETimeChange.bind(
                          this
                        )}
                        start={this.props.saturdayEveningSchedule.inTime}
                        end={this.props.saturdayEvenETValid.end}
                      />
                      <span>pm</span>
                      </div>
                      <div>
													<span className="help-block">{this.props.sunday && this.props.saturdayEveningSchedule.message}</span>
												</div>
                    </div>
                     
                   
                  </div>
                ) : null}
              </div>
            </div>
            </Col>
            {/* <Col lg={2}></Col> */}
</Row>

            

            <div
              className="warning-text"
              style={{
                padding: "5px",
                backgroundColor: " rgba(197, 91, 75, 1)",
                display: "flex",
                alignItems: "center",
                marginTop: "20px",
              }}
            >
              
              <li style={{ color: "#fff", fontSize: "16px", margin: "5px" }}>
              {this.props.friday.message && this.props.friday.message}
              </li>

              <li style={{ color: "#fff", fontSize: "16px", margin: "5px" }}>
                <strong>'M'</strong> stands for Morning Schedule.{" "}
              </li>
              <li style={{ color: "#fff", fontSize: "16px", margin: "5px" }}>
                <strong>'E'</strong> stands for Evening Schedule.{" "}
              </li>
            </div>
              
            <div className="clinic-banner" >
              {console.log(this.props.clinicBannerImage,this.state.bannerImage)}
              {this.props.clinicBanner !== null && this.props.clinicBanner !=="" && this.props.clinicBanner !== undefined && this.props.clinicBanner?
              <img src={this.props.clinicBanner} alt="Clinic Banner"  onClick={this.handleClickOpen} />:
              this.props.tempUpClinicBanner !== null && this.props.tempUpClinicBanner !=="" && this.props.tempUpClinicBanner !== undefined && this.props.tempUpClinicBanner?
               <img src={this.props.tempUpClinicBanner} alt="Clinic Banner"  onClick={this.handleClickOpen} />                                
              :
              this.props.clinicBannerImage !==null && this.props.clinicBannerImage !== "" && this.props.clinicBannerImage !=="noUserImage.jpg"  && this.state.bannerImage !==null && this.state.bannerImage !== "" && this.state.bannerImage !== undefined && !this.state.bannerImage.includes("undefined") && !this.state.bannerImage.includes("noClinicImage.jpg")?
              
              <img src={this.state.bannerImage} alt="Clinic Banner"  onClick={this.handleClickOpen} />    :
              <Avatar style={{height: '60px', width: '60px', cursor:'pointer',backgroundColor: '#fff'}}  onClick={this.handleClickOpen}>
              <CameraAltOutlined style={{fontSize:"40px",color:'#000'}}/>
              </Avatar>
  }
            </div>

            <div className="banner-info">
              <Typography variant="h5" style={{fontWeight:'bold',fontSize: '20px'}}>
                  Clinic Banner Image
              </Typography>
              <Typography variant="p" style={{fontFamily: 'roboto',fontStyle:'italic',fontWeight:'500',textAlign:'center'}}>
                  Please upload a banner image for your clinic. This image will be shown on your consultation forms.
              </Typography>

            </div>
            
            <Dialog
                            className="clinic-banner-upload-dialog"
                            onClose={this.handleClose}
                            aria-labelledby="customized-dialog-title"
                            open={this.state.viewProPicUploadDialog}
                          >
                            <DialogContent dividers>
                              <div className="clinic-banner-upload-content">
                                <div className="banner-icon-container">
                                  {this.state.tempImageObj? 
                                  <Avatar
                                  src={this.state.tempImageObj }
                                  className="banner-icon"
                                  variant="square"
                                ></Avatar>:
                                  (this.state.bannerImage !== null || this.props.tempUpClinicBanner !== null || this.props.tempUpClinicBanner !== '')?
                                  <Avatar
                                    src={this.props.tempUpClinicBanner? this.props.tempUpClinicBanner : this.state.bannerImage!==null || this.state.bannerImage !== "" && !this.state.bannerImageDeleted? this.state.bannerImage : "" }
                                    className="banner-icon"
                                    variant="square"
                                  ></Avatar>:<Avatar className="banner-icon" variant="square"> <CameraAltOutlined style={{fontSize:"60px"}}/></Avatar>}
                                </div>
                                <div>
                                  <button className="btn btn-square propic-upload-btn btn-w-120" style={{margin: '10px',verticalAlign:'middle'}}>
                                    <input
                                      name="image"
                                      onChange={this.handleClinicBannerImage}
                                      onClick={(event) => {
                                        event.target.value = null;
                                      }}
                                      type="file"
                                      style={{ display: "none" }}
                                      id="avatSelect"
                                    />
                                    <label
                                      className="editimg"
                                      htmlFor="avatSelect"
                                      style={{ cursor: "pointer",padding: '6px 12px',margin:'0px !important'  }}
                                    >
                                      <span className="btn-text">
                                        CHOOSE CLINIC BANNER
                                      </span>
                                      <span className=" editicon tooltip-custom fadeEffect"></span>
                                    </label>
                                  </button>
                                </div>
                                <div>
                                  <p>
                                    A rectangle image that will be shown on your
                                    clinic page. You can upload a
                                    JPG, GIF or PNG file (file size limit is 4
                                    MB, not smaller than 800x200)
                                  </p>
                                </div>
                              </div>
                            </DialogContent>
                            <DialogActions style={{justifyContent:'flex-end'}}>
                              {console.log(this.props.clinicBannerImage, this.state.bannerImage, this.props.clinicBanner, this.props.tempUpClinicBanner)}
                              {((this.props.clinicBannerImage !== null && this.props.clinicBannerImage !== "noUserImage.jpg" && !this.state.bannerImage.includes("noClinicImage.jpg") ) || this.props.clinicBanner || (this.props.tempUpClinicBanner !== '' && this.props.tempUpClinicBanner !== null)) ?
                              <div>
                                <button
                                  className="propic-dialog-close-btn btn-w-120"
                                  onClick={this.ConfirmClose}
                                >
                                  <span className="btn-text">REMOVE IMAGE</span>
                                </button>
                              </div>: null }

                              <div>
                                <button
                                  className="propic-dialog-close-btn btn-w-120"
                                  onClick={this.handleClose}
                                >
                                  <span className="btn-text">CANCEL</span>
                                </button>{" "}
                              </div>
                                      {this.state.tempImageObj &&
                               <div>
                                <button
                                  className="propic-dialog-close-btn btn-w-120"
                                  onClick={this.UploadClinicBanner}
                                >
                                  <span
                                    className="btn-text"
                                    
                                    // onClick={e=>this.props.UploadClinicBanner(e,this.state.tempImageObj,this.state.clinicImageObj)}
                                  >
                                    UPLOAD
                                  </span>
                                </button>{" "}
                              </div> }
                             </DialogActions> 
                           </Dialog> 





                           <Dialog
                            // className="propic-upload-dialog"
                            onClose={this.handleClose2}
                            aria-labelledby="customized-dialog-title"
                            className="removePropicDialog"
                            open={this.state.secondBanner}
                          >
                            <DialogContent
                              style={{
                                height: "200px !important",
                                padding: "0px !important",
                                backgroundColor: "#f2f2f2",
                              }}
                            >
                              <div
                                className="propic-upload"
                                style={{
                                  padding: "10px !important",
                                  backgroundColor: "#f2f2f2",
                                }}
                              >
                                <div
                                  style={{
                                    height: "60px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    marginTop: 0,
                                    padding: 10,
                                    backgroundColor: "#fff",
                                  }}
                                >
                                  <p
                                    style={{
                                      fontSize: "16px",
                                      fontFamily: "sansation_regular",
                                      fontWeight: 500,
                                      marginBottom: 0,
                                    }}
                                  >
                                    Remove Image
                                  </p>
                                </div>
                                <div className="removal-warn">
                                  <p
                                    style={{
                                      fontSize: "16px",
                                      fontFamily: "Roboto",
                                      textAlign: "center",
                                    }}
                                  >
                                    Click on OK to remove the image
                                  </p>
                                </div>
                              </div>
                            </DialogContent>

                            <DialogActions
                              style={{
                                justifyContent: "flex-end",
                                backgroundColor: "#f2f2f2",
                              }}
                            >
                              <div>
                                <button
                                  className="propic-dialog-close-btn btn-w-120"
                                  onClick={this.handleClose2}
                                >
                                  <span
                                    style={{
                                      fontFamily: "roboto",
                                      fontSize: 13,
                                    }}
                                    className="btn-text"
                                  >
                                    CANCEL
                                  </span>
                                </button>{" "}
                              </div>

                              {this.state.tempUploadedImage ||
                              this.state.imageCopy !== "noUserImage.jpg" ? (
                                <div>
                                  <button
                                    className="propic-dialog-close-btn btn-w-120"
                                    onClick={this.deleteImage}
                                  >
                                    <span
                                      style={{
                                        fontFamily: "roboto",
                                        fontSize: 13,
                                      }}
                                      className="btn-text"
                                    >
                                      OK
                                    </span>
                                  </button>
                                </div>
                              ) : null}
                            </DialogActions>
                          </Dialog>













   
          </div>
        </form>
        <div className="modal-footer bortop"></div>
      </div>
    );
  }
}

//this tells what state should expose on props
function mapStateToProps(state, ownProps) {
  return {};
}
//this tells what action should expose on props
//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(specialistActions, dispatch),
    logoutAction: bindActionCreators(dashboardActions, dispatch),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(Availability);
